import { ToggleButtonEntity } from "../entities/UIEntities/Form Entities/ToggleButtonEntity";
import { ListItem } from "../entities/UIEntities/ListItem";
import { ButtonItem } from "../entities/UIEntities/ButtonItem";
import { NavItemEntity } from "../entities/UIEntities/NavItem";
import { TableColumn } from "../entities/UIEntities/TableColumn";
import {
  BILLING_PROPS,
  CLIENT_ROUTES,
  GMT_PROPS,
  ALLOCATION_PROPS,
  PAGES,
  PARKERS_PROPS,
  RATE_CHARGE_BY_NAMES,
  RATE_CHARGE_BY_VALUES,
  DIALING_CODES,
  CHARGE_ACCOUNTS_PROPS,
  CAMPAIGN_PROPS,
  MAILING_LISTS_PROPS,
  MESSAGING_HISTORY_PROPS,
  MESSAGING_PARKERS_PROPS,
  RECIPIENTS_PROPS,
  HISTORY_PROPS,
  CAMPAIGN_TYPES,
  VEHICLE_TYPE
} from "../enums/Enums";
import Icons from "../resources/icons/Icons";
import Strings from "../resources/Strings";
import { 
  getBillingParkingLocation, 
  getEvRuleMenuItem,
  getBillingMenuItem,
  getDaysDivFromDaysStringArray  } from "../utils/BillingUtils";
import {
  getUserData,
  getAmount,
  getAppIcon,
  getCarNumber,
  getDuration,
  getElectricIcon,
  getLableByParkingStatus,
  getParkingLocations,
  getTime,
  getToken,
  getGmtUserData,
  getUserScopes,
  getAmountValue,
  getPhoneNumber,
  getNotes,
  getChargeAccountData,
  getContact,
  getValidation,
  getCampaignTypeIcon,
  getParkingLocationsBySites,
  isUserSubscribed,
} from "../utils/UsersUtils";

import { getISODateStringFromDurationString } from "../utils/CommonUtils";
import { getTokenParkingLocations } from "../utils/AllocationUtils";
import { LENGTHS } from "../config/Config";

export const NAVIGATION_ITEMS = [
  new NavItemEntity(
    PAGES.DASHBORAD,
    CLIENT_ROUTES.DASHBORAD,
    Icons.DASHBORAD,
    Icons.DASHBORAD2
  ),
  new NavItemEntity(
    PAGES.PARKERS,
    CLIENT_ROUTES.PARKERS,
    Icons.PARKERS,
    Icons.PARKERS2,
    true
  ),
  new NavItemEntity(
    PAGES.BILLING,
    CLIENT_ROUTES.BILLING,
    Icons.BILLING,
    Icons.BILLING2
  ),
  new NavItemEntity(
    PAGES.MESSAGING,
    CLIENT_ROUTES.MESSAGING,
    Icons.MESSAGING,
    Icons.MESSAGING2
  ),
  new NavItemEntity(
    PAGES.ALLOCATIONS,
    CLIENT_ROUTES.ALLOCATIONS,
    Icons.ALLOCATIONS,
    Icons.ALLOCATIONS2,
  ),
  new NavItemEntity(
    PAGES.VALIDATIONS,
    CLIENT_ROUTES.VALIDATIONS,
    Icons.BILLING,
    Icons.BILLING2
  ),
  new NavItemEntity(
    PAGES.HISTORY,
    CLIENT_ROUTES.HISTORY,
    Icons.HISTORY,
    Icons.HISTORY2
  ),
  new NavItemEntity(
    PAGES.ADMIN,
    CLIENT_ROUTES.ADMIN,
    Icons.ADMIN,
    Icons.ADMIN2
  ),
];
export const GUSETS_TABLE_COLUMNS = [
  new TableColumn(
    1,
    PARKERS_PROPS.CARD,
    Strings.PARKERS_COLUMNS_NAMES.CARD,
    getToken,
    (params) => params.row.mainCarToken?.displayValue,
    true,
    200
  ),
  new TableColumn(
    2,
    PARKERS_PROPS.PARKING,
    Strings.PARKERS_COLUMNS_NAMES.PARKING,
    getLableByParkingStatus,
    (params) => params.row.mainCarToken?.parkingStatus.toString()
  ),
  new TableColumn(
    3,
    PARKERS_PROPS.SITES,
    Strings.PARKERS_COLUMNS_NAMES.SITES,
    getParkingLocations,
    (params) => {},
    false
  ),
  new TableColumn(
    4,
    PARKERS_PROPS.PHONE_NUMBER,
    Strings.PARKERS_COLUMNS_NAMES.PHONE_NUMBER,
    getPhoneNumber,
    (params) => params.row.phoneNumber
  ),
  new TableColumn(
    5,
    PARKERS_PROPS.EMAIL,
    Strings.PARKERS_COLUMNS_NAMES.EMAIL,
    (params) => params?.row?.email,
    (params) => params?.row?.email,
    true,
    250
  ),
  new TableColumn(
    6,
    PARKERS_PROPS.CAR_NUMBER,
    Strings.PARKERS_COLUMNS_NAMES.CAR_NUMBER,
    getCarNumber,
    (params) => params.row.mainCarToken.car?.licensePlate
  ),
  new TableColumn(
    7,
    PARKERS_PROPS.TIME,
    Strings.PARKERS_COLUMNS_NAMES.TIME,
    getTime,
    (params) => params.row.mainCarToken?.parkingDeatils?.entranceDate,
    true, // null
    250
  ),
  new TableColumn(
    8,
    PARKERS_PROPS.DURATION,
    Strings.PARKERS_COLUMNS_NAMES.DURATION,
    getDuration,
    (params) => getISODateStringFromDurationString(getDuration(params)),
    true
  ),
  new TableColumn(
    9,
    PARKERS_PROPS.AMOUNT,
    Strings.PARKERS_COLUMNS_NAMES.AMOUNT,
    getAmount,
    getAmountValue
  ),
  new TableColumn(
    10,
    PARKERS_PROPS.SUBSCRIBED,
    Strings.PARKERS_COLUMNS_NAMES.SUBSCRIPTION_STATUS,
    (params) => isUserSubscribed(params.row?.utronUser) ? Strings.SUBSCRIBED : Strings.UNSUBSCRIBED,
    (params) => isUserSubscribed(params.row?.utronUser)
  ),
  new TableColumn(
    11,
    PARKERS_PROPS.ELECTRIC,
    Strings.PARKERS_COLUMNS_NAMES.ELECTRIC,
    getElectricIcon,
    (params) => params.row.mainCarToken?.car?.isEVSupported?.toString()
  ),
];
export const PARKERS_TABLE_COLUMNS = [
  new TableColumn(
    1,
    PARKERS_PROPS.NAME,
    Strings.PARKERS_COLUMNS_NAMES.NAME,
    getUserData,
    (params) => params.row.firstName,
    (params) => params.row.firstName,
    350
  ),
  new TableColumn(
    2,
    PARKERS_PROPS.PARKING,
    Strings.PARKERS_COLUMNS_NAMES.PARKING,
    getLableByParkingStatus,
    (params) => params.row.mainCarToken?.parkingStatus.toString()
  ),
  new TableColumn(
    3,
    PARKERS_PROPS.SITES,
    Strings.PARKERS_COLUMNS_NAMES.SITES,
    getParkingLocations,
    (params) => {},
    false
  ),
  new TableColumn(
    4,
    PARKERS_PROPS.PHONE_NUMBER,
    Strings.PARKERS_COLUMNS_NAMES.PHONE_NUMBER,
    (params) =>
      params.row.phoneNumber != "Null" ? `+${params.row.phoneNumber}` : ""
  ),
  new TableColumn(
    5,
    PARKERS_PROPS.USER_ADDITIONAL_DATA,
    Strings.PARKERS_COLUMNS_NAMES.NOTES,
    getNotes,
    getNotes
  ),
  new TableColumn(
    6,
    PARKERS_PROPS.SUBSCRIBED,
    Strings.PARKERS_COLUMNS_NAMES.SUBSCRIPTION_STATUS,
    (params) => isUserSubscribed(params.row?.utronUser) ? Strings.SUBSCRIBED : Strings.UNSUBSCRIBED,
    (params) => isUserSubscribed(params.row?.utronUser)
  ),
  new TableColumn(
    7,
    PARKERS_PROPS.APP,
    Strings.PARKERS_COLUMNS_NAMES.APP,
    getAppIcon,
    (params) => params.row.app?.toString()
  ),
];

// Messaging
export const CAMPAIGN_TABLE_COLUMNS = [
  new TableColumn(
    1,
    CAMPAIGN_PROPS.CAMPAIGN_NAME,
    Strings.CAMPAIGN_COLUMNS_NAMES.CAMPAIGN_NAME,
    (params) => params.row.name,
    (params) => params.row.name,
    250
  ),
  new TableColumn(
    2,
    CAMPAIGN_PROPS.DATE_CREATED,
    Strings.CAMPAIGN_COLUMNS_NAMES.DATE_CREATED,
    (params) => params.row.createdDate,
    (params) => new Date(params.row?.createdDate),
  ),
  new TableColumn(
    3,
    CAMPAIGN_PROPS.CAMPAIGN_TYPE,
    Strings.CAMPAIGN_COLUMNS_NAMES.CAMPAIGN_TYPE,
    getCampaignTypeIcon,
    (params) => params?.row?.campaignType,
    (params) => params?.row?.campaignType,
    250,
    (params) => params?.row?.classes?.centerIconCell
  ),
  new TableColumn(
    4,
    GMT_PROPS.SITES,
    Strings.GMT_COLUMNS_NAMES.SITES,
    (params) => getParkingLocationsBySites(params),
    (params) => {},
    false,
    170,
    (params) => params?.row?.classes?.centerIconCell
  ),
];

export const MESSAGING_HISTORY_TABLE_COLUMNS = [
  new TableColumn(
    1,
    MESSAGING_HISTORY_PROPS.CAMPAIGN_NAME,
    Strings.MESSAGING_HISTORY_COLUMNS_NAMES.CAMPAIGN_NAME,
    (params) => params?.row?.campaignInfo?.Name,
    (params) => params?.row?.campaignInfo?.Name,
    250
  ),
  new TableColumn(
    2,
    MESSAGING_HISTORY_PROPS.DATE_SENT,
    Strings.MESSAGING_HISTORY_COLUMNS_NAMES.DATE_SENT,
    (params) => params.row?.dateSent,
    (params) => new Date(params.row?.dateSent),
  ),
  new TableColumn(
    3,
    MESSAGING_HISTORY_PROPS.CAMPAIGN_TYPE,
    Strings.MESSAGING_HISTORY_COLUMNS_NAMES.CAMPAIGN_TYPE,
    (params) => getCampaignTypeIcon(params?.row?.campaignInfo),
    (params) => params?.row?.campaignInfo?.Type,
    (params) => params?.row?.campaignInfo?.Type,
    250,
    (params) => params?.row?.classes?.centerIconCell
  ),
  new TableColumn(
    4,
    MESSAGING_HISTORY_PROPS.NUMBER_OF_RECIPIENTS,
    Strings.MESSAGING_HISTORY_COLUMNS_NAMES.NUMBER_OF_RECIPIENTS,
    (params) => params.row.numberOfRecipients,
    (params) => params.row.numberOfRecipients,
    true,
    170,
    (params) => params?.row?.classes?.centerCell
  ),
  new TableColumn(
    5,
    MESSAGING_HISTORY_PROPS.TOTAL,
    Strings.MESSAGING_HISTORY_COLUMNS_NAMES.TOTAL,
    (params) => `$ ${parseFloat(params.row.total).toFixed(LENGTHS.TO_FIXED_LENGTH)}`,
    (params) => params.row.total,
  ),
  new TableColumn(
    6,
    MESSAGING_HISTORY_PROPS.SITES,
    Strings.MESSAGING_HISTORY_COLUMNS_NAMES.SITES,
    (params) => getParkingLocationsBySites(params),
    (params) => {},
    false,
    170,
    (params) => params?.row?.classes?.centerIconCell
  ),
];

export const MAILING_LIST_TABLE_COLUMNS = [
  new TableColumn(
    1,
    MAILING_LISTS_PROPS.MAILING_LIST_NAME,
    Strings.MAILING_LISTS_COLUMNS_NAMES.MAILING_LIST_NAME,
    (params) => params.row.name,
    (params) => params.row.name,
    250
  ),
  new TableColumn(
    2,
    MAILING_LISTS_PROPS.DATE_CREATED,
    Strings.MAILING_LISTS_COLUMNS_NAMES.DATE_CREATED,
    (params) => params.row?.dateCreated,
    (params) => new Date(params.row?.dateCreated),
  ),
  new TableColumn(
    3,
    MAILING_LISTS_PROPS.SIZE,
    Strings.MAILING_LISTS_COLUMNS_NAMES.SIZE,
    (params) => params.row.size,
    (params) => params.row.size,
    true,
    250,
    (params) => params?.row?.classes?.centerCell
  ),
  new TableColumn(
    4,
    MAILING_LISTS_PROPS.SITES,
    Strings.MAILING_LISTS_COLUMNS_NAMES.SITES,
    (params) => getParkingLocationsBySites(params),
    (params) => {},
    false,
    170,
    (params) => params?.row?.classes?.centerIconCell
  ),
];
/* Messaging table modals */
export const MESSAGING_PARKERS_TABLE_COLUMNS = [
  new TableColumn(
    1,
    MESSAGING_PARKERS_PROPS.NAME,
    Strings.MESSAGING_PARKERS_COLUMNS_NAMES.NAME,
    (params) => params.row.name,
    (params) => params.row.name,
    250
  ),
  new TableColumn(
    2,
    MESSAGING_PARKERS_PROPS.EMAIL,
    Strings.MESSAGING_PARKERS_COLUMNS_NAMES.EMAIL,
    (params) => params.row.email,
    (params) => params.row.email,
  ),
  new TableColumn(
    3,
    MESSAGING_PARKERS_PROPS.PHONE_NUMBER,
    Strings.MESSAGING_PARKERS_COLUMNS_NAMES.PHONE_NUMBER,
    (params) => params.row.phoneNumber,
    (params) => params.row.phoneNumber,
  ),
  new TableColumn(
    4,
    MESSAGING_PARKERS_PROPS.TYPE,
    Strings.MESSAGING_PARKERS_COLUMNS_NAMES.TYPE,
    (params) => params.row.type,
    (params) => params.row.type,
  ),
];

export const RECIPIENTS_TABLE_COLUMNS = [
  new TableColumn(
    1,
    RECIPIENTS_PROPS.NAME,
    Strings.RECIPIENTS_COLUMNS_NAMES.NAME,
    (params) => params.row.name,
    (params) => params.row.name,
    250
  ),
  new TableColumn(
    2,
    RECIPIENTS_PROPS.EMAIL,
    Strings.RECIPIENTS_COLUMNS_NAMES.EMAIL,
    (params) => params.row.email,
    (params) => params.row.email,
  ),
  new TableColumn(
    3,
    RECIPIENTS_PROPS.PHONE_NUMBER,
    Strings.RECIPIENTS_COLUMNS_NAMES.PHONE_NUMBER,
    (params) => params.row.phoneNumber,
    (params) => params.row.phoneNumber,
  ),
  new TableColumn(
    4,
    RECIPIENTS_PROPS.TYPE,
    Strings.RECIPIENTS_COLUMNS_NAMES.TYPE,
    (params) => params.row.type,
    (params) => params.row.type,
  ),
  // new TableColumn(
  //   5,
  //   RECIPIENTS_PROPS.SUBSCRIPTION_STATUS,
  //   Strings.RECIPIENTS_COLUMNS_NAMES.SUBSCRIPTION_STATUS,
  //   (params) => params.row.subscriptionStatus,
  //   (params) => params.row.subscriptionStatus,
  //   false
  // ),
];

export const INVALID_RECIPIENTS_TABLE_COLUMNS = [
  new TableColumn(
    1,
    RECIPIENTS_PROPS.NAME,
    Strings.RECIPIENTS_COLUMNS_NAMES.NAME,
    (params) => params.row.name,
    (params) => params.row.name,
    250
  ),
  new TableColumn(
    2,
    RECIPIENTS_PROPS.EMAIL,
    Strings.RECIPIENTS_COLUMNS_NAMES.EMAIL,
    (params) => params.row.email,
    (params) => params.row.email,
  ),
  new TableColumn(
    3,
    RECIPIENTS_PROPS.PHONE_NUMBER,
    Strings.RECIPIENTS_COLUMNS_NAMES.PHONE_NUMBER,
    (params) => params.row.phoneNumber,
    (params) => params.row.phoneNumber,
  ),
  new TableColumn(
    4,
    RECIPIENTS_PROPS.TYPE,
    Strings.RECIPIENTS_COLUMNS_NAMES.TYPE,
    (params) => params.row.type,
    (params) => params.row.type,
  ),
  // new TableColumn(
  //   5,
  //   RECIPIENTS_PROPS.SUBSCRIPTION_STATUS,
  //   Strings.RECIPIENTS_COLUMNS_NAMES.SUBSCRIPTION_STATUS,
  //   (params) => params.row.subscriptionStatus,
  //   (params) => params.row.subscriptionStatus,
  //   false
  // ),
  new TableColumn(
    5,
    RECIPIENTS_PROPS.REASON,
    Strings.RECIPIENTS_COLUMNS_NAMES.REASON,
    (params) => params.row.reason,
    (params) => params.row.reason,
  ),
];

export const RECIPIENTS_HISTORY_TABLE_COLUMNS = [
  new TableColumn(
    1,
    RECIPIENTS_PROPS.NAME,
    Strings.RECIPIENTS_COLUMNS_NAMES.NAME,
    (params) => params.row.name,
    (params) => params.row.name,
    250
  ),
  new TableColumn(
    2,
    RECIPIENTS_PROPS.EMAIL,
    Strings.RECIPIENTS_COLUMNS_NAMES.EMAIL,
    (params) => params.row.email,
    (params) => params.row.email,
  ),
  new TableColumn(
    3,
    RECIPIENTS_PROPS.PHONE_NUMBER,
    Strings.RECIPIENTS_COLUMNS_NAMES.PHONE_NUMBER,
    (params) => params.row.phoneNumber,
    (params) => params.row.phoneNumber,
  ),
  new TableColumn(
    4,
    RECIPIENTS_PROPS.TYPE,
    Strings.RECIPIENTS_COLUMNS_NAMES.TYPE,
    (params) => params.row.type,
    (params) => params.row.type,
  ),
  // new TableColumn(
  //   5,
  //   RECIPIENTS_PROPS.STATUS,
  //   Strings.RECIPIENTS_COLUMNS_NAMES.STATUS,
  //   (params) => params.row.status,
  //   (params) => params.row.status,
  //   false
  // ),
];

export const GMT_TABLE_COLUMNS = [
  new TableColumn(
    1,
    GMT_PROPS.NAME,
    Strings.GMT_COLUMNS_NAMES.NAME,
    getGmtUserData,
    (params) => params.row?.utronUser?.firstName,
    (params) => params.row?.utronUser?.firstName,
    250
  ),
  new TableColumn(
    2,
    GMT_PROPS.PHONE_NUMBER,
    Strings.GMT_COLUMNS_NAMES.PHONE_NUMBER,
    (params) =>
      params.row.phoneNumber && params.row.phoneNumber != "Null"
        ? `+${params.row.phoneNumber}`
        : ""
  ),
  new TableColumn(
    3,
    GMT_PROPS.EMAIL,
    Strings.GMT_COLUMNS_NAMES.EMAIL,
    (params) => params.row.email,
    (params) => params.row.email,
  ),
  new TableColumn(
    4,
    PARKERS_PROPS.SUBSCRIBED,
    Strings.GMT_COLUMNS_NAMES.SUBSCRIPTION_STATUS,
    (params) => isUserSubscribed(params.row?.utronUser) ? Strings.SUBSCRIBED : Strings.UNSUBSCRIBED,
    (params) => isUserSubscribed(params.row?.utronUser)
  ),
  new TableColumn(
    5,
    GMT_PROPS.SITES,
    Strings.GMT_COLUMNS_NAMES.SITES,
    getUserScopes,
    (params) => {},
    false
  ),
];

export const CHARGE_ACCOUNTS_TABLE_COLUMNS = [
  new TableColumn(
    1,
    CHARGE_ACCOUNTS_PROPS.NAME,
    Strings.CHARGE_ACCOUNTS_COLUMNS_NAMES.NAME,
    getChargeAccountData,
    (params) => params.row?.utronUser?.chargeAccount.name,
    (params) => params.row?.utronUser?.chargeAccount.name,
    250
  ),
  new TableColumn(
    2,
    CHARGE_ACCOUNTS_PROPS.EMAIL,
    Strings.CHARGE_ACCOUNTS_COLUMNS_NAMES.EMAIL,
    (params) => params?.row?.email,
    (params) => params?.row?.email,
  ),
  new TableColumn(
    3,
    CHARGE_ACCOUNTS_PROPS.CONTACT,
    Strings.CHARGE_ACCOUNTS_COLUMNS_NAMES.CONTACT,
    (params) => getContact(params),
    (params) => getContact(params),
    null,
    250
  ),
  new TableColumn(
    4,
    CHARGE_ACCOUNTS_PROPS.VALIDATION,
    Strings.CHARGE_ACCOUNTS_COLUMNS_NAMES.VALIDATION,
    (params) => getValidation(params),
    (params) => getValidation(params),
    false
  ),
  new TableColumn(
    5,
    CHARGE_ACCOUNTS_PROPS.NOTES,
    Strings.CHARGE_ACCOUNTS_COLUMNS_NAMES.NOTES,
    (params) => getNotes(params),
    (params) => getNotes(params),
    false
  )
];

export const BILLING_RULES_TABLE_COLUMNS = [
  new TableColumn(
    1,
    BILLING_PROPS.RULE_NAME,
    Strings.BILLING_COLUMNS_NAMES.RULE_NAME,
    (params) => params.row?.ruleName,
    (params) => params.row?.ruleName
  ),
  new TableColumn(
    2,
    BILLING_PROPS.LAST_MODIFIED,
    Strings.BILLING_COLUMNS_NAMES.LAST_MODIFIED,
    (params) => params.row?.modifiedDate,
    (params) => new Date(params.row?.modifiedDate),
  ),
  new TableColumn(
    3,
    BILLING_PROPS.SITES,
    Strings.BILLING_COLUMNS_NAMES.SITES,
    getBillingParkingLocation,
    (params) => params.row?.site?.displayName,
    false,
    170,
    (params) => params.row?.classes?.centerIconCell
  ),
  new TableColumn(
    4,
    BILLING_PROPS.VALID_DAYS,
    Strings.BILLING_COLUMNS_NAMES.VALID_DAYS,
    getDaysDivFromDaysStringArray, //intToDays,
    (params) => params.row?.days
  ),
  new TableColumn(
    5,
    BILLING_PROPS.VALID_HOURS,
    Strings.BILLING_COLUMNS_NAMES.VALID_HOURS,
    (params) => params.row?.validHours, 
    (params) => params.row?.startTime
  ),
  new TableColumn(
    6,
    BILLING_PROPS.USER_TYPES,
    Strings.BILLING_COLUMNS_NAMES.USER_TYPES,
    (params) => params.row?.ruleUserTypes, 
    (params) => params.row?.ruleUserTypes
    // (params) => params.row?.billingRuleToUserTypes[0].id,
    // (params) => params.row?.billingRuleToUserTypes[0].id
  ),
  new TableColumn (
    7,
    BILLING_PROPS.OPTIONS,
    "",
    getBillingMenuItem,
    false,
    false
  )
];

export const EV_RULES_TABLE_COLUMNS = [
  new TableColumn(
    1,
    BILLING_PROPS.RULE_NAME,
    Strings.BILLING_COLUMNS_NAMES.RULE_NAME,
    (params) => params.row?.ruleName,
    (params) => params.row?.ruleName
  ),
  new TableColumn(
    2,
    BILLING_PROPS.LAST_MODIFIED,
    Strings.BILLING_COLUMNS_NAMES.LAST_MODIFIED,
    (params) => params.row?.modifiedDate,
    (params) => new Date(params.row?.modifiedDate),
  ),
  new TableColumn(
    3,
    BILLING_PROPS.SITES,
    Strings.BILLING_COLUMNS_NAMES.SITES,
    getBillingParkingLocation,
    (params) => params.row?.site?.displayName,
    false,
    170,
    (params) => params.row?.classes?.centerIconCell
  ),
  new TableColumn(
    4,
    BILLING_PROPS.RATE,
    Strings.BILLING_COLUMNS_NAMES.RATE,
    (params) => params.row?.evRuleRateAmount, 
    (params) => params.row?.evRuleRateAmount.slice(0, -2), // sends only numeric for sort
    // (params) => params.row?.billingRuleRates
  ),
  new TableColumn(
    5,
    BILLING_PROPS.USER_TYPES,
    Strings.BILLING_COLUMNS_NAMES.USER_TYPES,
    (params) => params.row?.ruleUserTypes, 
    (params) => params.row?.ruleUserTypes
    // (params) => params.row?.billingRuleToUserTypes[0].id
  ),
  new TableColumn (
    6,
    BILLING_PROPS.OPTIONS,
    "",
    getEvRuleMenuItem,
    false,
    false
  )
];

// Billing Validations History
export const BILLING_HISTORY_TABLE_COLUMNS = [
  new TableColumn(
    1,
    HISTORY_PROPS.CHARGE_ACCOUNT,
    Strings.HISTORY_COLUMNS_NAMES.CHARGE_ACCOUNT,
    getChargeAccountData,
    (params) => params.row?.chargeAccount?.name,
    (params) => params.row?.chargeAccount?.name,
  ),
  new TableColumn(
    2,
    HISTORY_PROPS.DATE,
    Strings.HISTORY_COLUMNS_NAMES.DATE,
    (params) => params.row?.date,
    (params) => new Date(params.row?.date),
  ),
  new TableColumn(
    3,
    HISTORY_PROPS.VALIDATION_AMOUNT,
    Strings.HISTORY_COLUMNS_NAMES.VALIDATION_AMOUNT,
    (params) => params.row?.validationAmount,
    (params) => parseFloat(params.row?.validationAmount?.slice(1)),
  ),
  new TableColumn(
    4,
    HISTORY_PROPS.VALIDATION_TYPE,
    Strings.HISTORY_COLUMNS_NAMES.VALIDATION_TYPE,
    (params) => params.row?.validationType,
    (params) => params.row?.validationType,
  ),
  new TableColumn(
    5,
    HISTORY_PROPS.PHONE_NUMBER,
    Strings.HISTORY_COLUMNS_NAMES.PHONE_NUMBER,
    (params) => params.row?.phoneNumber,
    (params) => params.row?.phoneNumber,
  ),
  new TableColumn(
    6,
    HISTORY_PROPS.EMAIL,
    Strings.HISTORY_COLUMNS_NAMES.EMAIL,
    (params) => params.row?.email,
    (params) => params.row?.email,
  ),
];

// Allocation 
export const OCCUPIED_TABLE_COLUMNS = [
  new TableColumn(
    1,
    ALLOCATION_PROPS.PARKING_ALLOCATION, 
    Strings.OCCUPIED_COLUMNS_NAMES.PARKING_ALLOCATION,
    (params) => params.row?.token?.displayValue,
    (params) => params.row?.token?.displayValue,
    (params) => params.row?.token?.displayValue,
    350
  ),
  new TableColumn(
    2,
    ALLOCATION_PROPS.PARKER_NAME, 
    Strings.OCCUPIED_COLUMNS_NAMES.PARKER_NAME,
    (params) => `${params.row?.parker?.utronUser?.firstName || ""} ${params.row?.parker?.utronUser?.lastName || ""}`,
    (params) => params.row.mainCarToken?.parkingStatus.toString()
  ),
  new TableColumn(
    3,
    ALLOCATION_PROPS.ALLOCATION_TYPE,
    Strings.OCCUPIED_COLUMNS_NAMES.ALLOCATION_TYPE,
    (params) => `${params.row?.token?.userType?.type || ""}`, 
    (params) => `${params.row?.token?.userType?.type || ""}`, 
    false
  ),
  new TableColumn(
    4,
    ALLOCATION_PROPS.CAR_DETAILS,
    Strings.OCCUPIED_COLUMNS_NAMES.CAR_DETAILS,
    (params) => `${params.row?.car?.manufacturer || ""} ${params.row?.car?.licensePlate || ""}`, 
    (params) => `${params.row?.car?.manufacturer || ""} ${params.row?.car?.licensePlate || ""}`, 
    false
  ),
  new TableColumn(
    5,
    ALLOCATION_PROPS.ALLOCATION_SITES,
    Strings.OCCUPIED_COLUMNS_NAMES.PARKING_LOCATIONS,
    getTokenParkingLocations,
    (params) => {},
    false
  ),
  new TableColumn(
    6,
    ALLOCATION_PROPS.FOB,
    Strings.OCCUPIED_COLUMNS_NAMES.PARKERS_FOB,
    (params) => params.row?.fob
  )
];

// History
export const HISTORY_TABLE_COLUMNS = [
  new TableColumn(
    1,
    HISTORY_PROPS.DATE,
    Strings.HISTORY_COLUMNS_NAMES.DATE,
    (params) => params.row?.date,
    (params) => new Date(params.row?.date),
  ),
  new TableColumn(
    2,
    HISTORY_PROPS.VALIDATION_AMOUNT,
    Strings.HISTORY_COLUMNS_NAMES.VALIDATION_AMOUNT,
    (params) => params.row?.validationAmount,
    (params) => parseFloat(params.row?.validationAmount?.slice(1)),
  ),
  new TableColumn(
    3,
    HISTORY_PROPS.VALIDATION_TYPE,
    Strings.HISTORY_COLUMNS_NAMES.VALIDATION_TYPE,
    (params) => params.row?.validationType,
    (params) => params.row?.validationType,
  ),
  new TableColumn(
    4,
    HISTORY_PROPS.PHONE_NUMBER,
    Strings.HISTORY_COLUMNS_NAMES.PHONE_NUMBER,
    (params) => params.row?.phoneNumber,
    (params) => params.row?.phoneNumber,
  ),
  new TableColumn(
    5,
    HISTORY_PROPS.EMAIL,
    Strings.HISTORY_COLUMNS_NAMES.EMAIL,
    (params) => params.row?.email,
    (params) => params.row?.email,
  ),
];

export const CAMPAIGN_TYPE_LIST = [
  new ListItem(1,"Email", CAMPAIGN_TYPES.MAIL),
  new ListItem(2,"Text Message", CAMPAIGN_TYPES.MOBILE),
];

export const VEHICLE_TYPE_LIST = [
  new ListItem(1,"Car", VEHICLE_TYPE.CAR), 
  new ListItem(2,"Storage Pod", VEHICLE_TYPE.STORAGE),
];

export const CURRENCY_LIST = [
  new ListItem(1,"USD","USD"),
  new ListItem(2,"ILS","ILS")
];

export const SITE_TECH_LIST = [
  new ListItem(1,"Slide 1.0", 2),
  new ListItem(2,"Pace 3.0", 1),
];

export const CAR_COLORS = [
  new ListItem(1, "White", "White"),
  new ListItem(2, "Black", "Black"),
  new ListItem(3, "Gray", "Gray"),
  new ListItem(4, "Silver", "Silver"),
  new ListItem(5, "Red", "Red"),
  new ListItem(6, "Brown", "Brown"),
  new ListItem(7, "Green", "Green"),
  new ListItem(8, "Beige", "Beige"),
  new ListItem(9, "Orange", "Orange"),
  new ListItem(10, "Gold", "Gold"),
  new ListItem(11, "Yellow", "Yellow"),
  new ListItem(12, "Purple", "Purple"),
  new ListItem(13, "Blue", "Blue"),
];

export const WORKSPACE_ACTIONS_OPTIONS = [
  new ButtonItem(false, "Add", Icons.NEW_ENTITY),
  new ButtonItem(true, "Edit", Icons.EDIT_ITEM)
];

export const SCOPE_DETAILS_OPTIONS = [
  new ButtonItem(true, "New Scope", Icons.NEW_ENTITY),
  new ButtonItem(false, "Existing Scope", Icons.EXISTING_SCOPE)
];

export const SITE_SEGMENT_OPTIONS = [
  new ButtonItem(false, "Tenants", Icons.TENANTS),
  new ButtonItem(true, "Mixed Use", Icons.MIXED_USE),
];

export const FOB_ASSIGN_OPTIONS = [
  new ToggleButtonEntity(1, "New Parking Allocation", Icons.ADD_BUTTON),
  new ToggleButtonEntity(
    2,
    "Exsiting Parking Allocation",
    Icons.EXSISTING_PARKING_ALLOCATION
  ),
];

export const VERIFICATION_TIMER = 120000;
export const VERIFICATION_CODE_DIGITS = 6;
export const MAX_VALID_DAYS = 254;
export const DEFAULT_TIME = "00:00:00";
export const DEFAULT_DIALING_CODE = DIALING_CODES.US;

export const CHARGE_BY_LIST = [
  new ListItem(1, "1 Hour", {name: RATE_CHARGE_BY_NAMES.HOURS, duration: RATE_CHARGE_BY_VALUES.HOURS}),
  new ListItem(2, "30 Minutes", {name: RATE_CHARGE_BY_NAMES.MINUTES, duration: RATE_CHARGE_BY_VALUES.MINUTES}),
];